import Meta from '@/utils/RouterMeta'
import Router from '@/utils/Router'

const child = [
    Router.instance({
        path: 'vehicles',
        name: 'vehicles',
        component: () => import('@/pages/vehicle/index'),
        meta: Meta.instance({
            title: 'Свои',
            btnName: 'Свои',
            icon: 'mdi-car-arrow-left',
            permissions: ['logist', 'manager', 'moderator', 'admin']
        })
    }),
    Router.instance({
        path: '/vehicle/:id?',
        name: 'vehicle',
        props: true,
        component: () => import('@/pages/vehicle/test'),
        meta: Meta.instance({
            title: 'СВОИ АВТОМОБИЛИ',
            show: false,
            permissions: ['logist', 'manager', 'moderator', 'admin']
        })
    }),
    Router.instance({
        path: 'vehicles-hire',
        name: 'vehicles-hire',
        component: () => import('@/pages/vehicle_hire/index'),
        meta: Meta.instance({
            title: 'Арендованные',
            btnName: 'Арендованные',
            icon: 'mdi-car-arrow-right',
            permissions: ['logist', 'manager', 'moderator', 'admin']
        })
    }),
    Router.instance({
        path: '/vehicle/hire/:id?',
        name: 'vehicle-hire',
        props: true,
        component: () => import('@/pages/vehicle_hire/test'),
        meta: Meta.instance({
            title: 'АРЕНДОВАННЫЕ АВТОМОБИЛИ',
            show: false,
            permissions: ['logist', 'manager', 'moderator', 'admin']
        })
    }),
]

export const carPark = [
    Router.instance({
        meta: Meta.instance({
            icon: 'mdi-parking',
            title: 'АВТОПАРК',
            btnName: 'АВТОПАРК',
            permissions: ['logist', 'manager', 'moderator', 'admin']
        }),
        children: [
            Router.instance({
                meta: Meta.instance({
                    title: 'Автомобили',
                    icon: 'mdi-car-multiple',
                    btnName: 'Автомобили',
                    subGroup: true,
                    permissions: ['logist', 'manager', 'moderator', 'admin']
                }),
                children: child
            }),
            Router.instance({
                path: 'drivers',
                name: 'drivers',
                component: () => import('@/pages/driver/index'),
                meta: Meta.instance({
                    title: 'Водители',
                    icon: 'mdi-account-cowboy-hat',
                    btnName: 'Водители',
                    permissions: ['logist', 'manager', 'moderator', 'admin']
                })
            }),
            Router.instance({
                path: 'driver/:id?',
                name: 'driver',
                props: true,
                component: () => import('@/pages/driver/test'),
                meta: Meta.instance({
                    title: 'Водители',
                    icon: 'mdi-account-cowboy-hat',
                    btnName: 'Водители',
                    show: false,
                    permissions: ['logist', 'manager', 'moderator', 'admin']
                })
            })
        ]
    })
]
